import { render, staticRenderFns } from "./VersionItem.vue?vue&type=template&id=653ea750&"
import script from "./VersionItem.vue?vue&type=script&lang=ts&"
export * from "./VersionItem.vue?vue&type=script&lang=ts&"
import style0 from "./VersionItem.vue?vue&type=style&index=0&id=653ea750&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports